import React, { useState, useContext } from "react";
import { MdGroups, MdChevronLeft, MdAccountCircle, MdSupervisedUserCircle } from "react-icons/md";
import { VscChevronDown } from "react-icons/vsc";
import { useField } from "formik";
import { Dropdown } from "react-bootstrap";

import FieldError from "../../shared/FieldError";
import { Settings } from "../../helpers/Contexts";
import DropdownMenu from "../../shared/DropdownMenu";
const SelectAssignee = ({ setFieldValue, ...props }) => {
  const settings = useContext(Settings);
  const [icon, setIcon] = useState("");
  const [field, meta] = useField(props);

  const [activeList, setActiveList] = useState({
    support_groups: settings.support_groups,
    group: "",
    agents: [],
  });
  const [show, setShow] = useState(false);

  const Toggle = React.forwardRef(({ children, onClick }, ref) => (
    <div
      ref={ref}
      onClick={(e) => {
        onClick(e);
        e.preventDefault();
        !show ? setShow(true) : setShow(false);
      }}
    >
      {children}
    </div>
  ));

  return (
    <>
      <label>Assignee</label>
      <Dropdown show={show} className="dropdown-select">
        <Dropdown.Toggle as={Toggle}>
          {icon == "agent" && <MdAccountCircle className="group-icon dropdown" />}
          {icon == "group" && <MdSupervisedUserCircle className="group-icon dropdown" />}
          {!icon && ""}
          {field.value && field.value}
          {!field.value && "Select a support group or an agent to be assigned"}
          <VscChevronDown className="chevron-icon" />
        </Dropdown.Toggle>
        <Dropdown.Menu as={DropdownMenu} className="no-padding border">
          {!activeList.group && !!settings.support_groups.length && (
            <>
              <Dropdown.Header>Support Groups</Dropdown.Header>
              {settings.support_groups.map((group, i) => (
                <Dropdown.Item
                  key={i}
                  as={"li"}
                  onClick={() => {
                    console.log(group);
                    setActiveList({
                      ...activeList,
                      group: { ...group },
                      agents: group.support_agents,
                    });
                    setIcon("group");
                    setFieldValue("assignee_support_group_id", group.id);
                    setFieldValue("assignee_id", "");
                    setFieldValue("assignee", group.name);
                  }}
                >
                  <MdGroups className="group-icon dropdown" />
                  {group.name}
                </Dropdown.Item>
              ))}
            </>
          )}
          {activeList.group.name && (
            <>
              <Dropdown.Header
                id="menu-item"
                onClick={() => {
                  setActiveList({ group: "", agents: [] });
                }}
              >
                <MdChevronLeft className="left-icon" />
                <MdGroups className="group-icon dropdown" />
                {"Support Groups"}
              </Dropdown.Header>{" "}
              <Dropdown.Item
                as={"li"}
                onClick={() => {
                  setShow(false);
                  setIcon("group");
                  setFieldValue("assignee_id", "");
                  setFieldValue("assignee_support_group_id", activeList.group.id);
                  setFieldValue("assignee", activeList.group.name);
                }}
              >
                <MdSupervisedUserCircle className="group-icon dropdown" />
                {activeList.group.name}
              </Dropdown.Item>{" "}
              <Dropdown.Header>{"Support Agents"}</Dropdown.Header>
              {activeList.agents.map((agent, i) => (
                <Dropdown.Item
                  key={i}
                  as="li"
                  onClick={(e) => {
                    setShow(false);
                    setIcon("agent");
                    setFieldValue("assignee_id", agent.id);
                    setFieldValue("assignee", agent.name);
                    setFieldValue("assignee_support_group_id", activeList.group.id);
                  }}
                >
                  <MdAccountCircle className="group-icon dropdown" />
                  {agent.name}
                </Dropdown.Item>
              ))}
            </>
          )}
        </Dropdown.Menu>
      </Dropdown>{" "}
      {meta.touched && meta.error ? <FieldError error={meta.error} /> : null}
    </>
  );
};
export default SelectAssignee;
